import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import "../../styles/components/legalCeme/LegalCeme.scss";
import evio from "../../styles/images/evio.svg";

let counter;

class PrivateConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    counter = 1;
  }

  render() {
    return (
      <div id="pc">
        <div className="evio-logo">
          <img src={evio} alt="" />
        </div>
        <br />
        <div className="pc-title">
          <Translate value="legalCeme_PC_mainTitle1" />
          <br />
          <Translate value="legalCeme_PC_mainTitle2" />
          <br />
        </div>
        <br />
        <div className="tab1">
          <div className="tabT">
            <Translate value="legalCeme_PC_tab1_title" />
          </div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L1" />
          </div>
          <div className="tabRowRight">
            <Translate value="legalCeme_PC_tabs_L2" />
          </div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L3" />
          </div>
          <div className="tabRowRight">
            <Translate value="legalCeme_PC_tabs_L4" />
          </div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L5" />
          </div>
          <div className="tabRowRight">
            <Translate value="legalCeme_PC_tabs_L6" />
          </div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L7" />
          </div>
          <div className="tabRowRight">
            <Translate value="legalCeme_PC_tabs_L8" />
          </div>
          <div className="tabRowBottomLeft">
            <Translate value="legalCeme_PC_tabs_L9" />
          </div>
          <div className="tabRowBottomRight">
            <Translate value="legalCeme_PC_tabs_L10" />
          </div>
        </div>
        <br />
        <div className="tab2">
          <div className="tabT">
            <Translate value="legalCeme_PC_tab2_title" />
          </div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L1" />
          </div>
          <div className="tabRowRight"></div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L3" />
          </div>
          <div className="tabRowRight"></div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L5" />
          </div>
          <div className="tabRowRight"></div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tab2_L5" />
          </div>
          <div className="tabRowRight"></div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L7" />
          </div>
          <div className="tabRowRight"></div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tabs_L9" />
            <br />
            <Translate value="legalCeme_PC_tab2_L6" />
          </div>
          <div className="tabRowRight"></div>
          <div className="tabRowLeft">
            <Translate value="legalCeme_PC_tab2_L7" />
          </div>
          <div className="tabRowRight"></div>
          <div className="tabRowBottomLeft">
            <Translate value="legalCeme_PC_tab2_L8" />
          </div>
          <div className="tabRowBottomRight"></div>
        </div>
        <br />
        <div className="pc-title">
          <Translate value="legalCeme_PC_title" />
        </div>
        <br />
        <div className="pc-text">
          <Translate value="legalCeme_PC_text1" />
          <span>
            <a href=" https://evio.pt/" target="_blank "> https://evio.pt/</a>
          </span>
          <span> .</span>
          <br />
          <br />
          {<ol start={counter}>{this.renderListItems(5)}</ol>}
        </div>
      </div>
    );
  }

  // uses a global counter to render Private Conditions list items
  renderListItems(totalPoints) {
    let list = [];
    let childrenPC = [2, 0, 5, 3, 2];

    while (counter <= totalPoints) {
      list.push(
        <li key={counter}>
          {counter === 2 ? (
            <span>
              <span className="title">
                <Translate value={`legalCeme_PC_title2`} />
              </span>
              <div className="tab3">
                <div className="tabRowTopLeft">
                  <Translate value="legalCeme_PC_tab3_L1" />
                </div>
                <div className="tabRowTopRight"></div>
                <div className="tabRowMiddleLeft">
                  <Translate value="legalCeme_PC_tab3_L2" />
                </div>
                <div className="tabRowMiddleRight"></div>
                <div className="tabRowBottomLeftTab3">
                  <Translate value="legalCeme_PC_tab3_L3" />
                </div>
                <div className="tabRowBottomRightTab3"></div>
              </div>
              <br />
            </span>
          ) : (
            <span>
              <span className="title">
                <Translate value={`legalCeme_PC_title${counter}`} />
              </span>
              <span>
                {
                  <div className="indent">
                    <ol>
                      {this.renderListItemChildren(childrenPC[counter - 1])}
                    </ol>
                  </div>
                }
              </span>
            </span>
          )}
        </li>
      );
      counter++;
    }
    return list;
  }

  // renders children for each list item
  renderListItemChildren(Number) {
    let childrenListItems = [];

    for (let i = 1; i <= Number; i++) {
      childrenListItems.push(
        <li key={i}>
          <Translate value={`legalCeme_PC_point${counter}_child${i}`} />
        </li>
      );
    }
    return childrenListItems;
  }
}

export default PrivateConditions;
